import script from "./WallDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./WallDisplay.vue?vue&type=script&setup=true&lang=js"

import "./WallDisplay.vue?vue&type=style&index=0&id=0cfe4181&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cfe4181"]])

export default __exports__